import { render } from "./JJMainLayout.vue?vue&type=template&id=cbf69190&scoped=true"
import script from "./JJMainLayout.vue?vue&type=script&lang=js"
export * from "./JJMainLayout.vue?vue&type=script&lang=js"

import "./JJMainLayout.vue?vue&type=style&index=0&id=cbf69190&scoped=true&lang=css"

import exportComponent from "/var/www/html/clientwebview/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbf69190"]])

export default __exports__